export enum RecordingStatus {
  IDLE = 'idle',
  RECORDING = 'recording'
}
